<script setup>
import {message, Modal} from 'ant-design-vue';
import {defineEmits, ref, watch} from 'vue';
import {useRoute} from "vue-router";
import {useAuthStore} from "@/stores/auth";

const formRef = ref(null);

const emit = defineEmits(['update:visible', 'success', 'cancel']);

const isVisible = ref(false);

const handleCancel = () => {
  isVisible.value = false;
  emit('update:visible', false);
  emit('cancel');
};

const handleOk = async () => {
  try {
    await formRef.value.validate();

    const authStore = useAuthStore();

    await authStore.loginModal(formState.value.email, formState.value.password).then(() => {
      message.success('Đăng nhập thành công!');
      completedData();
    }).catch((error) => {
      message.error(error);
    });

  } catch (error) {
    console.log('Form validation failed!', error);
    message.error('Vui lòng kiểm tra lại thông tin!')
  }
};

const formState = ref({
  email: '',
  password: '',
});

const completedData = () => {
  isVisible.value = false;
  emit('update:visible', false);
  emit('success');
}

const route = useRoute();
watch(
    () => route.path,
    (newPath) => {
      if (["/login", "/register", "/reset-password", "/forgot-password"].includes(newPath)) {
        isVisible.value = false;
      } else {
        const player = localStorage.getItem('player');
        const user = localStorage.getItem('user');
        if (!player || !user) {
          isVisible.value = ["/user/bang-dieu-khien"].includes(newPath);
        } else {
          isVisible.value = false;
        }
      }
    },
    {immediate: true}
);

</script>

<template>
  <Modal
      :open="isVisible"
      title="Đăng nhập tài khoản"
      width="600px"
      okText="Đăng nhập"
      cancelText="Hủy bỏ"
      @cancel="handleCancel"
      @ok="handleOk"
  >
    <div class="row input_login">
      <div class="col-12">
        <a-form
            ref="formRef"
            :model="formState"
            layout="vertical"
        >
          <a-form-item :rules="[
                  { required: true, message: 'Vui lòng nhập email!' },
                  { type: 'email', message: 'Email không hợp lệ!' }
                ]" label="Email" name="email">
            <a-input v-model:value="formState.email" placeholder="Vui lòng nhập email"/>
          </a-form-item>

          <a-form-item :rules="[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]"
                       label="Mật khẩu" name="password">
            <a-input-password v-model:value="formState.password"
                              placeholder="Vui lòng nhập mật khẩu"/>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </Modal>
</template>

<style scoped>

</style>